module.exports = __webpack_public_path__ + "static/media/homepage_intro_bg.2b36e595.jpg";